import { useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { SET_WALLET, GET_WALLET } from '@syndicated-wallet/constants/walletEvents';
import { isWalletUpdated } from '@syndicated-wallet/helpers';

export default ({
    // prevPaymentsInfo ref is only updated on wallet:updated or wallet:ui-updated (by Modal).
    // by comparing prevPaymentsInfo and paymentsInfo,
    // we know if paymentsInfo is changed due to user's interaction with Grid/NDS
    // and only send wallet:set for those cases.
    prevPaymentsInfo,
    paymentsInfo,
    isPaymentsInfoLoaded,
}) => {
    useEffect(() => {
        const hasPaymentsInfoChangedFromGrid = isWalletUpdated(prevPaymentsInfo?.current, paymentsInfo);
        const isGridLoadedWithPaymentsInfo =
            prevPaymentsInfo?.current?.isPaymentsInfoLoaded && paymentsInfo?.isPaymentsInfoLoaded;

        if (isGridLoadedWithPaymentsInfo && hasPaymentsInfoChangedFromGrid) {
            eventBus.emit(GET_WALLET, (data) => {
                const updatedField = isWalletUpdated(data, paymentsInfo);
                if (updatedField) {
                    eventBus.emit(SET_WALLET, { paymentsInfo });
                    prevPaymentsInfo.current = { ...paymentsInfo };
                }
            });
        }
    }, [paymentsInfo, prevPaymentsInfo, isPaymentsInfoLoaded]);

    return null;
};
